import React from "react";
import { CurrencyInput } from "../../lib";

const ConversionsInput = ({ title, value, onChange, onEnter }) => {
  const { two, one } = value || {};
  return (
    <div className="ConversionsInput">
      <CurrencyInput
        label="Last Year"
        status="New contacts added during the last 12 months"
        onChange={(one) => onChange({ ...value, one })}
        value={one}
        format="0,0"
        autoFocus
      />
      <CurrencyInput
        label="Two Years Ago"
        status="New contacts added during the 12 months prior"
        onChange={(two) => onChange({ ...value, two })}
        value={two}
        format="0,0"
      />
    </div>
  );
};

export default ConversionsInput;



// WEBPACK FOOTER //
// ./src/assess/question/ContactsInput.js